import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.constructor";
import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.typed.uint8-array";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "D:/java/\u4E00\u7F51\u901A\u529E(\u529E\u4E8B\u5927\u53852.0)/\u4E00\u7F51\u901A\u529E\u524D\u7AEFPC/pc/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { previewFiles, previewTxtFiles, getPreviewTxtFiles } from "@/api/file/files";
export default {
  name: "previewFile",
  data: function data() {
    return {
      configData: null,
      docEditor: null,
      loading: false,
      typeArray: ["html", "txt"],
      content: ""
    };
  },
  computed: _objectSpread({}, mapGetters(["previewFileData"])),
  watch: {
    previewFileData: {
      handler: function handler(newVal, oldVal) {
        if (newVal && newVal.state) {
          this.getFileConfig();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted: function mounted() {},
  methods: {
    handleClose: function handleClose() {
      this.content = "";
      this.$store.commit("setPreviewFileData", {
        data: this.previewFileData.data,
        state: false
      });
    },
    getFileConfig: function getFileConfig() {
      var _this = this;

      console.log(44444, this.previewFileData.data.fileSuffix);
      this.loading = true;

      if (this.typeArray.indexOf(this.previewFileData.data.fileSuffix) < 0) {
        previewFiles(this.previewFileData.data.previewPath, this.previewFileData.data.fileId).then(function (res) {
          _this.loading = false;

          if (res.data.code == 0) {
            _this.configData = res.data.data;

            _this.appendScript();
          } else {
            _this.$notify.closeAll();

            _this.$notify.error({
              title: "错误",
              message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(res.data.msg)
            });

            _this.handleClose();
          }
        }).catch(function (error) {
          _this.$notify.closeAll();

          _this.$notify.error({
            title: "错误",
            message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(error.msg)
          });

          _this.handleClose();
        });
      } else {
        // getPreviewTxtFiles(
        //   this.previewFileData.data.previewPath,
        //   this.previewFileData.data.fileId
        // )
        //   .then(res => {
        //     this.loading = false;
        //     this.content=res.data;
        //   })
        //   .catch(error => {
        //     this.$notify.closeAll();
        //     this.$notify.error({
        //       title: "错误",
        //       message: `预览出错,请稍后重试,${error.msg}`
        //     });
        //     this.handleClose();
        //   });
        previewTxtFiles(this.previewFileData.data.previewPath, this.previewFileData.data.fileId).then(function (res) {
          _this.loading = false;

          if (res.status == 200) {
            if (res.data.code === 1) {
              _this.$notify.closeAll();

              _this.$notify.error({
                title: "错误",
                message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(res.data.msg)
              });

              _this.handleClose();
            } else {
              _this.readFileData(res.data.presignedUrl, res.data.originalFileName, res.data.charset);
            }
          } else {
            _this.$notify.closeAll();

            _this.$notify.error({
              title: "错误",
              message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(res.data.msg)
            });

            _this.handleClose();
          }
        }).catch(function (error) {
          _this.$notify.closeAll();

          _this.$notify.error({
            title: "错误",
            message: "\u9884\u89C8\u51FA\u9519,\u8BF7\u7A0D\u540E\u91CD\u8BD5,".concat(error.msg)
          });

          _this.handleClose();
        });
      }
    },
    readFileData: function readFileData(url, name, charset) {
      var _this2 = this;

      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";

      x.onload = function (e) {
        _this2.loading = false;
        var encoding = "utf-8";
        var reader = new FileReader();

        reader.onload = function (event) {
          // 读取完毕后输出结果
          _this2.content = event.target.result;
        };

        if (_this2.previewFileData.data.fileSuffix === "txt") {
          var blob = new Blob([e.target.result], {
            type: "text/html"
          });
          /*this.isUtf8(blob).then(res => {
              console.log(777, res);
              encoding = res ? "gb2312" : "utf-8";
              reader.readAsText(x.response, encoding);
            });*/

          reader.readAsText(x.response, charset);
        } else {
          reader.readAsText(x.response, charset);
        } // reader.readAsText(x.response, charset);

      };

      x.send();
    },

    /**
     * @description: 二进制形式读取txt文件 并判断其是否为utf-8
     * @param {type}
     * @return:
     */
    readFile: function readFile(file) {
      console.log(file);
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function (evt) {
          resolve(evt.target.result);
        };

        reader.readAsArrayBuffer(file);
      });
    },
    isUtf8: function () {
      var _isUtf = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var res, firstCode;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.readFile(file);

              case 2:
                res = _context.sent;
                console.log(res);
                firstCode = new Uint8Array(res)[0];
                return _context.abrupt("return", firstCode >= 33 && firstCode <= 126);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function isUtf8(_x) {
        return _isUtf.apply(this, arguments);
      }

      return isUtf8;
    }(),
    editorInit: function editorInit() {
      require(["emmet/emmet"], function (data) {
        // this is huge. so require it async is better
        window.emmet = data.emmet;
      });

      require("brace/theme/chrome");

      require("brace/ext/language_tools"); //language extension prerequsite...


      require("brace/mode/html");

      require("brace/mode/json");

      require("brace/snippets/json");

      require("brace/snippets/html");

      this.$refs.editor.editor.setShowFoldWidgets(true);
    },
    appendScript: function appendScript() {
      var _this3 = this;

      // window.addEventListener("touchmove", { passive: false });
      var al = document.getElementsByTagName("script");
      var joine = [];

      for (var i = 0; i < al.length; i++) {
        joine.push(al[i].getAttribute("src"));
      }

      var ajoine = joine.join(",");

      if (ajoine.indexOf(this.configData.api) < 0) {
        // 创建script标签，引入外部文件
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = this.configData.api;
        document.getElementsByTagName("head")[0].appendChild(script);

        script.onload = script.onreadystatechange = function () {
          if (!_this3.readyState || _this3.readyState == "loaded" || _this3.readyState == "complete") {
            _this3.сonnectEditor();
          }

          script.onload = script.onreadystatechange = null;
        };
      } else {
        this.сonnectEditor();
      }
    },
    innerAlert: function innerAlert(message) {
      if (console && console.log) console.log(message);
    },
    onReady: function onReady() {
      innerAlert("Document editor ready");
    },
    onDocumentStateChange: function onDocumentStateChange(event) {
      var title = document.title.replace(/\*$/g, "");
      document.title = title + (event.data ? "*" : "");
    },
    onRequestEditRights: function onRequestEditRights() {
      location.href = location.href.replace(RegExp("mode=view&?", "i"), "");
    },
    onError: function onError(event) {
      console.log(event);
      if (event) innerAlert(event.data);
    },
    onOutdatedVersion: function onOutdatedVersion(event) {
      location.reload(true);
    },
    сonnectEditor: function onnectEditor() {
      var config = this.configData.config;
      this.docEditor = new DocsAPI.DocEditor("iframeEditor", config);
    }
  }
};